(function() {
	'use strict';

	angular
		.module('assetCommon')
		.provider('assetCommonConfig', assetCommonConfig);

	function assetCommonConfig() {
		var previewFormatPrefix = 'Amber Preview';
		var extractedTextFormatName = 'Extracted Text';
		var dropEventName = 'dropTarget.dropped';
		var filesSelectedEventName = 'fileSelect.filesSelected';
		var logBufferSize = 50;
		var assetServiceBaseUri;
		var accountServicesBaseUri;
		var signInUri;
		var signOutUri;
		var singleSignInScriptUri;

		this.setLogBufferSize = function (value) {
			logBufferSize = value;
		};

		this.setAssetServiceBaseUri = function (value) {
			assetServiceBaseUri = value;
		};

		this.setAccountServicesBaseUri = function (value) {
			accountServicesBaseUri = value;
		};

		this.setSignInUri = function (value) {
			signInUri = value;
		};

		this.setSignOutUri = function (value) {
			signOutUri = value;
		};

		this.setSingleSignInScriptUri = function (value) {
			singleSignInScriptUri = value;
		};

		this.setPreviewFormatPrefix = function (value) {
			previewFormatPrefix = value;
		};

		this.setExtractedTextFormatName = function (value) {
			extractedTextFormatName = value;
		};

		this.setDropEventName = function (value) {
			dropEventName = value;
		};

		this.setFilesSelectedEventName = function (value) {
			filesSelectedEventName = value;
		};
		this.$get = config;

		function config() {
			return {
				previewFormatPrefix: previewFormatPrefix,
				extractedTextFormatName: extractedTextFormatName,
				assetServiceBaseUri: assetServiceBaseUri,
				logBufferSize: logBufferSize,
				dropEventName: dropEventName,
				filesSelectedEventName: filesSelectedEventName,
				accountServicesBaseUri: accountServicesBaseUri,
				signInUri: signInUri,
				signOutUri: signOutUri,
				singleSignInScriptUri: singleSignInScriptUri
			};
		}
	}
})();